export const enum UserRoleType {
    USER = "user",
    MANAGER = "manager",
    ADMIN = "admin",
    API = "api",
    SAYSIMPLE = "saysimple",
}
